import React, { useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import { useFetchPropertyResidentsQuery } from '@@/services/property';
import MultiSelectInput from '@@/components/Inputs/MultiSelectInput';

const SelectPropertyResidentsInput: React.FC<{
  id: string;
  propertyId: string;
  label: string;
  className?: string;
  isMulti?: boolean;
  placeholder?: string;
  error?: FieldError;
  control: any;
}> = ({
  id,
  propertyId,
  label,
  className,
  isMulti = true,
  placeholder,
  error,
  control,
}) => {
  const { data: residents } = useFetchPropertyResidentsQuery(propertyId);

  const selectPropertyResidentsInput = useMemo(() => {
    if (residents) {
      return [...residents]
        .map((resident) => {
          const flatId = resident.accounts?.[0].apartmentNumber;
          const label = flatId
            ? `${resident.lastName.toUpperCase()} ${resident.firstName} (${flatId})`
            : `${resident.lastName.toUpperCase()} ${resident.firstName}`;
          return {
            id: String(resident.id),
            label,
          };
        })
        .sort((r1, r2) => {
          if (r1.label < r2.label) {
            return -1;
          }

          if (r1.label > r2.label) {
            return 1;
          }

          return 0;
        });
    }

    return [];
  }, [residents]);

  if (!residents) {
    return null;
  }

  return (
    <MultiSelectInput
      control={control}
      id={id}
      label={label}
      placeholder={placeholder}
      error={error}
      options={selectPropertyResidentsInput}
      isMulti={isMulti}
      className={className}
    />
  );
};

export default SelectPropertyResidentsInput;
